import { MinusCircleFilled } from "@ant-design/icons";
import { Input } from "antd";
import { clsx } from "clsx";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { Variant } from "Types/Journey";

import { NumericOnlyInput } from "../../Shared/SharedInputs/NumericOnlyInput";

import styles from "./VariantsFormItem.module.scss";

export function VariantFormRow({
    variant,
    canRemove,
    nameError,
    weightError,
    onRemove,
    onNameChange,
    onWeightChange,
}: {
    variant: Variant;
    canRemove: boolean;
    nameError: boolean;
    weightError: boolean;
    onRemove: (index: number) => void;
    onNameChange: (id: number) => void;
    onWeightChange: () => void;
}): JSX.Element {
    return (
        <div
            key={`${variant.name}Container`}
            className={clsx(styles.variantRowContainer, { [styles.spacedVariantRow]: variant.id != 1 })}
        >
            <RVFormFloatingLabelWrap
                name={["variants", `variant${variant.id}`, "name"]}
                placeholder="Variant Name"
                key={`variant${variant.id}Name`}
                noPadding
            >
                <Input
                    key={`${variant.id}NameInput`}
                    onChange={() => onNameChange(variant.id)}
                    className={clsx({ [styles.inputError]: nameError })}
                />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                name={["variants", `variant${variant.id}`, "weight"]}
                key={`variant${variant.id}Weight`}
                noPadding
            >
                <NumericOnlyInput
                    key={`variant${variant.id}WeightInput`}
                    style={{ width: "90px" }}
                    addonAfter={"%"}
                    maxDigits={2}
                    onChange={onWeightChange}
                    className={clsx({ [styles.weightInputError]: weightError })}
                />
            </RVFormFloatingLabelWrap>
            <div key={`variant${variant.id}-remove-button`} className={styles.variantRowRemoveButton}>
                <MinusCircleFilled
                    className={canRemove ? styles.active : styles.disabled}
                    onClick={() => {
                        onRemove(variant.id);
                    }}
                />
            </div>
        </div>
    );
}
